import _ from "lodash";
import { ajax } from "../../app/core/ajax";
import { clone } from "../core/core";
import * as divisionRegion from "../core/division.region";
import { LocalizedLanguage } from "../core/ll";
import { user } from "../core/user";
import { emptyFn, isFunction } from "../core/util";
import { buildODataKendoParams } from "../data/buildODataKendoParams";
import { dataSource } from "../data/dataSource";
import { searchTypes } from "../data/searchTypes";
import * as searchOptions from "./searchOptions";

export function chart(options) {
    options = options || {};

    var id = getIdFromOptions(options);

    if ($("#" + id).data("kendoChart")) {
        return $("#" + id).data("kendoChart");
    }

    // Copied from grid.js
    initializeOptions(options);
    initializeDataSource(options);

    options.divisions = options.divisions === undefined ? options.searchType.divisions : options.divisions;
    options.regions = options.regions === undefined ? options.searchType.regions : options.regions;

    if ((options.divisions || options.regions) && user && user.companyData && user.companyData.DivisionAndRegionEnabled) {

        options.divisionsNavigationTypes = options.divisionsNavigationTypes === undefined ? options.searchType.divisionsNavigationTypes : options.divisionsNavigationTypes;
        options.regionsNavigationTypes = options.regionsNavigationTypes === undefined ? options.searchType.regionsNavigationTypes : options.regionsNavigationTypes;
        options.divisionsFilterOverride = options.divisionsFilterOverride === undefined ? options.searchType.divisionsFilterOverride : options.divisionsFilterOverride;
        options.regionsFilterOverride = options.regionsFilterOverride === undefined ? options.searchType.regionsFilterOverride : options.regionsFilterOverride;
        options.regionNotRequired = options.regionNotRequired === undefined ? options.searchType.regionNotRequired : options.regionNotRequired;
        options.title = options.title === undefined ? options.searchType.title : options.title;
        options.divisionsAndRegionsAndMyStuff = options.divisionsAndRegionsAndMyStuff === undefined ? options.searchType.divisionsAndRegionsAndMyStuff : options.divisionsAndRegionsAndMyStuff;
        options.defaultDivisionSearchOption = options.defaultDivisionSearchOption === undefined ? options.searchType.defaultDivisionSearchOption : options.defaultDivisionSearchOption;
        options.defaultRegionSearchOption = options.defaultRegionSearchOption === undefined ? options.searchType.defaultRegionSearchOption : options.defaultRegionSearchOption;

        var divAndRegOptions = divisionRegion.createDivisionAndRegionSearchOptions(options);

        if (options.divisions) {
            options.searchOptions.push(divAndRegOptions.division);
        }

        if (options.regions) {
            if (!options.isSearchPopUp) {
                divAndRegOptions.region.showSearchPopUp = true;
            }
            options.searchOptions.push(divAndRegOptions.region);
        }
    }

    options.searchOptions = searchOptions.initialize({ options: options, _id: id }).searchOptions;

    if (options.searchOptions.length > 0) {
        searchOptions.render({ options: options, _id: id });
    } else {
        $("#" + id + "_SearchContainer").css("min-height", "0");
    }

    var kChart = options.chartObject || $(id);
    if (kChart.length == 0) {
        kChart = $("#" + id);
    }

    var dataBound = options.dataBound || emptyFn;

    options.dataBound = function (e) {

        var kendoChart = kChart.data("kendoChart"),
            data = kendoChart.dataSource.data();

        dataBound.apply(this, [e]);
    };

    // delete options.zScreen;
    kChart.kendoChart(options);

    // if (kChart.find(".k-grid-toolbar").children().length == 0) {
    //     kChart.find(".k-grid-toolbar").remove();
    // }

    kendo.bind("#" + id + "_SearchContainer .bind-label", LocalizedLanguage);
    kendo.bind("#" + id + "_SearchContainer_Actions .bind-label", LocalizedLanguage);

    return kChart.data("kendoChart");
}

function getIdFromOptions(options) {
    var chartId = options.id;

    if (!chartId && options.chartObject) {
        chartId = $(options.chartObject).attr("id");
    }

    if (chartId.indexOf(options.zScreen.id) != 0 && options.zScreen && options.zScreen.id) {
        chartId = options.zScreen.id + "_" + chartId;
    }

    options.id = chartId;

    return chartId;
}

function initializeOptions(options) {

    if (options.liveFilter == "false") {
        options.liveFilter = false;
    }
    options.divisions = options.divisions !== undefined ? options.divisions : true;
    options.regions = options.regions !== undefined ? options.regions : true;
    options.searchOptions = options.searchOptions || [];
    options.hideSearchOptions = options.hideSearchOptions;
    options.autoBind = options.autoBind !== undefined ? options.autoBind : false;
    options.dataSource = options.dataSource || null;
    options.entityTypes = options.entityTypes || [];

    var entityTypeIndex = options.entityTypes[0] != null ? options.entityTypes[0].indexOf("/") : -1;
    var mainEntityType = "";
    if (entityTypeIndex != -1) {
        mainEntityType = options.entityTypes[0].substring(0, entityTypeIndex);
    } else if (options.entityTypes[0] && options.entityTypes[0].length > 0) {
        mainEntityType = options.entityTypes[0];
    }

    options.mainEntityType = options.mainEntityType || mainEntityType;

    options.toolbar = options.toolbar;
    options.excel = {
        allPages: true,
        sortable: true,
        filterable: true,
        reorderable: true,
        resizable: true
    };
    options.sortable = options.sortable || { allowUnsort: true, mode: "single" };
    options.toolbar = options.toolbar || [];
    options.parent = options.parent || "";
    options.url = options.url || null;

    options.schema = options.schema || null;
    options.show = options.show || null;
    options.hide = options.hide || null;

    options.liveFilter = options.liveFilter != undefined ? options.liveFilter : true;
    options.expand = options.expand || "";
    options.select = options.select || "";
    options.xAxis = options.xAxis;
    options.yAxis = options.yAxis;
    options.searchType = options.searchType || searchTypes.generate(options.mainEntityType);
    options.entityTypes = options.entityTypes.concat(options.searchType.entityTypes).getUnique();

    if (options.useSearchType) {
        options.columnOrder = options.overrideColumnOrder || options.columnOrder.concat(options.searchType.columnOrder || []);
        options.columns = options.columns.concat(options.searchType.columns || []);

        if ($.isFunction(options.select)) {
            var originalSelect = options.select;
            options.select = function () {
                return originalSelect() + ", " + options.searchType.select;
            };
        } else {
            options.select = options.select ? options.select + ", " + options.searchType.select : options.searchType.select;
        }

        options.expand = options.expand ? options.expand + ", " + options.searchType.expand : options.searchType.expand;
        if (typeof options.useSearchType.useSearchOptions === "undefined" || options.useSearchType.useSearchOptions) {
            options.searchOptions = options.searchOptions.concat(options.searchType.searchOptions || []);
        }
        if (options.filter && options.searchType.filter) {
            options.filter = "(" + options.filter + ") AND (" + options.searchType.filter + ")";
        } else {
            options.filter = options.filter || options.searchType.filter;
        }
    }
}

function initializeDataSource(options) {
    if (!options.dataSource && (options.url || options.entityTypes.length > 0)) {
        if (!options.url && options.entityTypes.length > 0) {
            options.url = "" + options.mainEntityType;
        }

        /* $.each(options.entityTypes, function (index, type) {
            if (options.expand.length > 0) {
                options.expand += ", ";
            }
            var expand = type;
            if (expand.indexOf("/") != -1) {
                expand = expand.substring(expand.indexOf("/") + 1);
            }

            options.expand += expand;
        }); */

        var urlPrefix = options.urlPrefix || "";
        var ds = dataSource({
            pageSize: options.defaultPageSize || 10,
            sort: options.sort || [],
            transport: {
                read: {
                    url: urlPrefix + options.url,
                    beforeSend: options.beforeSend
                },
                update: {
                    url: urlPrefix + options.url,
                    beforeSend: options.beforeSend
                },
                parameterMap: function (data, type) {
                    if (type == "update") {
                        var dto = clone(data.models[0]);

                        $.each(options.dtoDeletes, function (index, deleteField) {
                            delete dto[deleteField];
                        });

                        return JSON.stringify(dto);
                    }
                    var sort = options.sort;
                    var filter = options.filter;
                    var select = options.select;
                    var expand = options.expand;

                    if (isFunction(sort)) {
                        sort = sort();
                    }

                    if (isFunction(filter)) {
                        filter = filter();
                    }

                    if (isFunction(select)) {
                        select = select();
                    }

                    if (isFunction(expand)) {
                        expand = expand();
                    }

                    var grid = $("#" + options.id).data("kendoChart");

                    var selectExpression = select;

                    $.each((grid as any).columns, function (index, column) {
                        // TODO: Potentially use another field instead of Field

                        if (column.field) {
                            var field = column.field;

                            if (column.isCode) {
                                field = column.codeFieldIdName;
                            }

                            var refactoredColumn1 = field.replaceAll("/", "."),
                                refactoredColumn2 = field.replaceAll(".", "/");

                            if (!column.hidden &&
                                selectExpression.indexOf(field) == -1 &&
                                selectExpression.indexOf(refactoredColumn1) == -1 &&
                                selectExpression.indexOf(refactoredColumn2) == -1) {

                                if (selectExpression.length > 0) {
                                    selectExpression += ", ";
                                }

                                selectExpression += field;
                            }
                        }
                    });

                    // Last Ditch effort to get the expand for all the selects
                    var selects = selectExpression.split(","),
                        expands = [];

                    $.each(expand.split(","), function () {
                        expands.push($.trim(this));
                    });

                    $.each(selects, function (index, value) {
                        value = value.replaceAll(".", "/");
                        if (value.indexOf("/") != -1) {

                            var newExpand = value.substr(0, value.lastIndexOf("/"));
                            expands.push($.trim(newExpand));
                        }
                    });

                    var replaceUDFComboFields = function (item) {
                        if (item.field) {
                            var column = _.find(options.columns as any[],
                                function (c) { return c.field == item.field; });
                            if (column && column.UserDefinedListId) {
                                item.field = item.field.replace("UDF_", "UDFLV_") + ".CodeNumber";
                            }
                        } else if (item.filters) {
                            $.each(item.filters, function (index, itemFilters) {
                                replaceUDFComboFields(itemFilters);
                            });
                        }
                    };

                    if (data.filter && data.filter.filters) {
                        $.each(data.filter.filters, function (index, item) {
                            replaceUDFComboFields(item);
                        });
                    }

                    if (data.sort) {
                        $.each(data.sort, function (index, item) {
                            replaceUDFComboFields(item);
                        });
                    }

                    return buildODataKendoParams({
                        data: data,
                        sortExpression: sort,
                        filterExpression: filter,
                        selectExpression: selectExpression,
                        expandExpression: expands.getUnique().join(", ")
                    });
                }
            }
        });

        options.dataSource = ds;
    }
}
